import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Print = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.25 10.75H6.75M6.75 13.75V19.25C6.75 20.3546 7.64543 21.25 8.75 21.25H15.25C16.3546 21.25 17.25 20.3546 17.25 19.25V13.75M6.75 13.75H17.25M6.75 13.75V17.25H4.75C3.64543 17.25 2.75 16.3546 2.75 15.25V8.75003C2.75 7.64546 3.64543 6.75003 4.75 6.75003H19.25C20.3546 6.75003 21.25 7.64546 21.25 8.75003V15.25C21.25 16.3546 20.3546 17.25 19.25 17.25H17.25V13.75M8.75 2.75003H15.25C16.3546 2.75003 17.25 3.64546 17.25 4.75003V6.75003H6.75V4.75003C6.75 3.64546 7.64543 2.75003 8.75 2.75003Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 2.00003C7.34315 2.00003 6 3.34318 6 5.00003V6.00003H5C3.34315 6.00003 2 7.34318 2 9.00003V15C2 16.6569 3.34315 18 5 18H6V19C6 20.6569 7.34315 22 9 22H15C16.6569 22 18 20.6569 18 19V18H19C20.6569 18 22 16.6569 22 15V9.00003C22 7.34318 20.6569 6.00003 19 6.00003H18V5.00003C18 3.34318 16.6569 2.00003 15 2.00003H9ZM16 6.00003V5.00003C16 4.44775 15.5523 4.00003 15 4.00003H9C8.44772 4.00003 8 4.44775 8 5.00003V6.00003H16ZM16 15H8V19C8 19.5523 8.44772 20 9 20H15C15.5523 20 16 19.5523 16 19V15ZM6 11C6 10.4477 6.44772 10 7 10H9C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H7C6.44772 12 6 11.5523 6 11Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
